import {
  GET_COMPANY_BRANCH_PROVIDER,
  GET_COMPANY_BRANCH_PROVIDER_FAILURE,
  GET_COMPANY_BRANCH_PROVIDER_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const getCompanyBranchProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_COMPANY_BRANCH_PROVIDER:
      return { ...state, loading: true };
    case GET_COMPANY_BRANCH_PROVIDER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case GET_COMPANY_BRANCH_PROVIDER_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default getCompanyBranchProviderReducer;
